import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  Menu,
  X,
  Trophy,
  UserRound,
  ClipboardList,
  Info,
  Home,
} from "lucide-react";

import logo from "/bpl.png";

function Header() {
  const [mobileMenu, setMobileMenu] = useState(false);

  const navItems = [
    {
      name: "Home",
      path: "/",
      icon: Home,
    },
    {
      name: "About",
      path: "/about",
      icon: Info,
    },
    {
      name: "Registration",
      path: "/form",
      icon: ClipboardList,
    },
    {
      name: "Profile",
      path: "/profile",
      icon: UserRound,
    },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 shadow-sm backdrop-blur-md">
      
      {/* Top Tournament Bar */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-orange-500">
        <div className="mx-auto flex w-[94%] max-w-7xl items-center justify-center gap-2 py-1.5 text-center text-xs font-semibold tracking-wide text-white sm:text-sm">
          <Trophy className="h-4 w-4" />
          <span>BPL Season 2 • Badgaw Premier League</span>
        </div>
      </div>

      {/* Main Header */}
      <div className="mx-auto flex h-20 w-[94%] max-w-7xl items-center justify-between">

        {/* Logo */}
        <Link
          to="/"
          className="flex items-center transition-transform duration-200 hover:scale-[1.02]"
        >
          <img
            src={logo}
            alt="BPL - Badgaw Premier League Season 2"
            className="h-14 w-auto object-contain sm:h-16"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden items-center gap-1 md:flex">

          {navItems.map((item) => {
            const Icon = item.icon;

            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `group flex items-center gap-2 rounded-lg px-4 py-2.5 text-sm font-semibold transition-all duration-200 ${
                    isActive
                      ? "bg-red-50 text-red-600"
                      : "text-gray-700 hover:bg-gray-50 hover:text-red-600"
                  }`
                }
              >
                <Icon className="h-4 w-4 transition-transform group-hover:scale-110" />
                {item.name}
              </NavLink>
            );
          })}

          {/* Register CTA */}
          <Link
            to="/form"
            className="ml-3 flex items-center gap-2 rounded-lg bg-gradient-to-r from-red-600 to-orange-500 px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-red-200 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
          >
            <Trophy className="h-4 w-4" />
            Register Now
          </Link>

        </nav>

        {/* Mobile Menu Button */}
        <button
          type="button"
          onClick={() => setMobileMenu(!mobileMenu)}
          className="rounded-lg border border-gray-200 p-2.5 text-gray-700 transition hover:bg-gray-50 md:hidden"
          aria-label="Toggle navigation"
        >
          {mobileMenu ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenu && (
        <div className="border-t border-gray-100 bg-white px-4 pb-5 pt-3 shadow-lg md:hidden">

          <nav className="mx-auto flex max-w-md flex-col gap-1">

            {navItems.map((item) => {
              const Icon = item.icon;

              return (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenu(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-3 rounded-xl px-4 py-3.5 text-sm font-semibold transition ${
                      isActive
                        ? "bg-red-50 text-red-600"
                        : "text-gray-700 hover:bg-gray-50"
                    }`
                  }
                >
                  <Icon className="h-5 w-5" />
                  {item.name}
                </NavLink>
              );
            })}

            {/* Mobile Register Button */}
            <Link
              to="/form"
              onClick={() => setMobileMenu(false)}
              className="mt-2 flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-red-600 to-orange-500 px-5 py-3.5 text-sm font-bold text-white shadow-md"
            >
              <Trophy className="h-5 w-5" />
              Register Now
            </Link>

          </nav>
        </div>
      )}
    </header>
  );
}

export default Header;